import { render } from "./BaseLink.vue?vue&type=template&id=790a360a&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=ts"
export * from "./BaseLink.vue?vue&type=script&lang=ts"

import "./BaseLink.vue?vue&type=style&index=0&id=790a360a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-790a360a"

export default script